import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark as faBookmarkSolid } from "@fortawesome/free-solid-svg-icons";
import { toggleBookmark } from "../../features/bookmark/bookmarkSlice";
import "./CardStyles.css";
import { Mentor } from "../../pages/Mentorpal/MentorPal";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { useWithSessionData } from "../../hooks/use-with-session-data";

export interface CardProps {
  mentor: Mentor;
  isMentorsPage: boolean;
  onClick: () => void;
}

const Card = ({
  mentor,
  isMentorsPage,
  onClick,
}) => {
  const {name, title, thumbnail, mentorUrl} = mentor;
  const dispatch = useAppDispatch();
  const bookmarkedMentors = useAppSelector(
    (state) => state.bookmark.bookmarkedMentors
  );
  const isBookmarked = bookmarkedMentors.some((mentor) => mentor.name === name);
  const { userId, sessionId } = useWithSessionData();


  const handleBookmark = (e) => {
    e.stopPropagation();


    if (!name) {
      console.warn("⚠️ Bookmark skipped due to missing name.");
      return;
    }

    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "Mentor", name, {});
    sendEvent(eventData);


    dispatch(
      toggleBookmark({
        name,
        title,
        thumbnail,
        mentorUrl,
      })
    );
  };

  const handleCardClick = (e) => {
    if (!e.target.closest(".card-bookmark-button")) {
      onClick && onClick();
    }
  };

  return (
    <div
      className={`card ${isMentorsPage ? "card-mentors-page" : ""}`}
      onClick={handleCardClick}
    >
      <p className="card-title">{name}</p>
      <div className="card-link">
        <img src={thumbnail} alt={title} className="card-thumbnail" />
      </div>
      <h3 className="card-subtitle">{title}</h3>

      <button
        data-cy="bookmark-card"
        onClick={handleBookmark}
        className="card-bookmark-button"
        aria-label={isBookmarked ? "Remove Bookmark" : "Add Bookmark"}
      >
        <FontAwesomeIcon
          //icon={isBookmarked ? faBookmarkSolid : faBookmark}
          icon={isBookmarked ? faBookmarkSolid : faBookmarkSolid}
          className={`card-bookmark-icon ${isBookmarked ? "blue" : "white"}`}
        />
      </button>
    </div>
  );
};

export default Card;
